import {
  Popover,
  PopoverTrigger,
  Text,
  PopoverHeader,
  PopoverArrow,
  PopoverCloseButton,
  PopoverContent,
  PopoverBody,
} from "@chakra-ui/react";

import usePageData from "@hooks/usePageData";

const Disclaimer = () => {
  const tooltipText = usePageData("$.page.data.disclaimer_tooltip");
  return (
    <>
      {tooltipText && tooltipText[0] !== null ? (
        <Text
          fontWeight="400"
          fontSize="12px"
          lineHeight="150%"
          color="textSecondary"
        >
          Please read{" "}
          <Popover placement="top" trigger="hover">
            <PopoverTrigger>
              <Text display="inline" color="primary" cursor="pointer">
                disclaimer
              </Text>
            </PopoverTrigger>
            <PopoverContent
              color="textSecondary"
              bg="tooltipBackground"
              borderColor="tooltipBackground"
              textAlign="left"
              p="16px"
              borderRadius="8px"
              maxW="290px"
            >
              <PopoverHeader
                fontWeight="600"
                fontSize="20px"
                lineHeight="24px"
                border="0"
                p="0"
              >
                Disclaimer
              </PopoverHeader>
              <PopoverArrow bg="tooltipBackground" />
              <PopoverCloseButton top="12px" />
              <PopoverBody
                fontWeight="400"
                fontSize="12px"
                lineHeight="18px"
                p="8px 0 0"
              >
                {tooltipText}
              </PopoverBody>
            </PopoverContent>
          </Popover>
        </Text>
      ) : null}
    </>
  );
};

export default Disclaimer;
